import { Header, LoadingSpinner, WrapKontomatik } from '@components/Generic'
import { observer } from 'mobx-react'
import { useContext, useEffect, useState } from 'react'
import { useInterval } from 'usehooks-ts'
import { StoreContext } from '@store/Root.store'
import { axiosInstance } from '@methods/axiosConfig'
import { devLog } from '@methods/devLog'
import { forceRedirect } from '@methods/forceRedirect'
import { getUrlParam } from '@/methods/urlParams'
import { API_URL } from '@/constants/apiUrl'

export const ProgressPageKontomatik = observer(() => {
  const store = useContext(StoreContext)
  const shouldUploadBankStatement = getUrlParam('shouldUploadBankStatement') === 'true'
  const { progressPage: trans } = store.TranslationsState.translations
  const [verified, setVerified] = useState(false)
  const [verifyFail, setVerifyFail] = useState(false)

  const handlePooling = async () => {
    try {
      const res = await axiosInstance.get(`${API_URL}/kontomatik/check-status`, {
        withCredentials: true,
      })

      if (res.data) {
        const { status } = res.data
        if (status === 'finished') {
          setVerified(true)
        }
      }
    } catch (e) {
      setVerifyFail(true)
      devLog(e)
    }
  }

  const handleComplete = async () => {
    try {
      if (verifyFail && shouldUploadBankStatement) {
        store.ScenarioState.nextPage()
      } else if (!verifyFail) {
        forceRedirect(`${API_URL}/kontomatik/complete`)
      }
    } catch (e) {
      devLog(e)
    }
  }

  useInterval(
    () => {
      !verified && handlePooling()
    },
    !verified ? 3000 : null
  )

  useEffect(() => {
    if (verified || verifyFail) {
      handleComplete()
    }
  }, [verified, verifyFail])

  useEffect(() => {
    const kontomatikSelectedBank = getUrlParam('kontomatikSelectedBank')

    if (
      kontomatikSelectedBank === 'Pko' ||
      kontomatikSelectedBank === 'Inteligo' ||
      kontomatikSelectedBank === 'PkoApi' ||
      kontomatikSelectedBank === 'pko'
    ) {
      store.ScenarioState.nextPage()
    }
  }, [])

  return (
    <WrapKontomatik>
      <div className="layout__margined m-0-0-15">
        <Header>{trans.heading}</Header>
      </div>
      <LoadingSpinner />
    </WrapKontomatik>
  )
})
